export default "__VITE_ASSET__DCs21eFG__"